import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

const RouteChangeFocusResetter = () => {
  const location = useLocation();
  const { pathname, key: locationKey } = location;
  useEffect(() => {
    const topOfPage = document.getElementById('top-of-page');
    topOfPage.focus();
  }, [pathname]);
  return (
    <div
      style={{ display: 'none' }}
      data-testid="location-key-element"
      data-location-key={locationKey}
    />
  );
};

export default RouteChangeFocusResetter;
